import React from 'react';
import { Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';
import Container from '../../../../constants/Container';

const data = [
  { name: 'Jan', active: 80, completed: 90, revenue: 50 },
  { name: 'Feb', active: 75, completed: 60, revenue: 65 },
  { name: 'Mar', active: 90, completed: 100, revenue: 80 },
  { name: 'Apr', active: 110, completed: 140, revenue: 70 },
  { name: 'May', active: 85, completed: 180, revenue: 95 },
  { name: 'Jun', active: 100, completed: 130, revenue: 75 },
  { name: 'Jul', active: 130, completed: 210, revenue: 140 },
  { name: 'Aug', active: 90, completed: 100, revenue: 90 },
  { name: 'Sep', active: 70, completed: 160, revenue: 60 },
  { name: 'Oct', active: 110, completed: 130, revenue: 100 },
  { name: 'Nov', active: 150, completed: 170, revenue: 150 },
  { name: 'Dec', active: 120, completed: 160, revenue: 80 }
];

const ChartDashboard: React.FC = () => {
  return (
    <Container padding>
      <div style={{ width: '100%', height: 320, fontSize: "12px" }}>
        <ResponsiveContainer>
          <ComposedChart
            data={data}
            margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid
              stroke="#1e3a4c"
              strokeWidth={0.5}
              strokeDasharray="1 2"
              vertical={false}    
              horizontal={true} 
            />
            <XAxis dataKey="name" strokeWidth={0.5} stroke="#4b5563" fontSize={12} />
            <YAxis stroke="#4b5563" strokeWidth={0.5} fontSize={12} />
            <Tooltip />
            <Legend />

            <Bar dataKey="active" name="Active Orders" fill="#2563eb" barSize={18} />
            <Bar dataKey="completed" name="Completed Orders" fill="#16a34a" barSize={18} />
            <Line type="monotone" dataKey="revenue" name="Sales Revenue" stroke="#4ade80" fontSize={12} strokeWidth={2} dot={{ r: 3 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Container>
  );
};

export default ChartDashboard;
